import { db } from "@/firebaseConfig";

const foodCollection = db.collection("food");

const saveFood = async data => {
  foodCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("Food successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateFood = async (id, data) => {
  foodCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Food successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteFood = async id => {
  foodCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Food successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getFoodById = async id => {
  return foodCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getLastFood = async () => {
  return foodCollection
    .orderBy("updated_on", "desc")
    .limit(1)
    .get();
};

export {
  foodCollection,
  saveFood,
  updateFood,
  deleteFood,
  getFoodById,
  getLastFood
};
